var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreyInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1171275112"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55",
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#575B67"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1171275109"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4479",
    x: 13.125,
    y: 13.2296,
    width: 3.33333,
    height: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4480",
    x: 13.125,
    y: 6.56262,
    width: 3.33333,
    height: 3.33333,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyInfoIcon);
export default __webpack_public_path__ + "static/media/grey-info-icon.645db9410e107433ed0eb50bcc42c164.svg";
export { ForwardRef as ReactComponent };